// SolidStart route racine : redirige vers le cockpit si authentifié, sinon /login.

import { onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function HomePage() {
  const navigate = useNavigate();
  onMount(async () => {
    try {
      // Check session via BetterAuth API
      const r = await fetch("/api/auth/get-session", { credentials: "include" });
      if (r.ok) {
        const data = await r.json();
        if (data?.user) {
          navigate("/console/session", { replace: true });
          return;
        }
      }
    } catch (_err) {
      /* silencieux */
    }
    navigate("/login", { replace: true });
  });

  return (
    <div
      style={{
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "min-height": "100vh",
        color: "#94a3b8",
        background: "#0f172a",
        "font-family": "system-ui, sans-serif",
      }}
    >
      <p>Chargement...</p>
    </div>
  );
}
